// @flow

import styled from 'styled-components';

export const Direction = styled.div`
  direction: ${({ dir }) => dir};
`;
